/**
 * @fileoverview Component for the modal containing instructions on creating a new Saved Filter.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {SmallDialog} from '/ui/components/modal/dialog';

import * as styles from '/src/com/yext/listingslaunchstorm/js/enterprise/selectentities/selectentities.module.scss';

/**
 * @param {{
 *   show: boolean,
 *   onClose: function(): void,
 * }} props
 * @returns
 */
export function NewSavedFilterModal({
  show,
  onClose,
}) {
  const title = yext.msg('Creating a New Saved Filter...');
  const ctas = {
    cancel: {
      type: 'cancel',
      text: yext.msg('Cancel'),
    },
    primary: {
      type: 'active',
      text: yext.msg('Confirm'),
      callback: onClose,
    },
  };

  const createOrLaunch = yext.msg('Create a new saved filter using the page that has been launched. <a href="{0}" target="_blank">Launch the page again here</a> if it did not open.', Routes.entities());

  return (
    <SmallDialog show={show} onHideDialog={onClose} title={title} callToAction={ctas}>
      <div className={styles.modalContent}>
        <div dangerouslySetInnerHTML={{__html: createOrLaunch}} />

        <div>
          {yext.msg('When you are done creating your saved filter, click \'Confirm\' so that it can be added as an option. Otherwise, click \'Cancel\' to return to the setup process.')}
        </div>
      </div>
    </SmallDialog>
  );
}
